<template>
  <div class="card" :class="classes">
    <div class="card-body">
      <div class="card-order">
        <h5 class="mb-2">{{ label }}</h5>
        <h1 class="text-right">
          <i class="fa mt-2 float-left" :class="icon"></i>
          <span>{{ total }}</span>
        </h1>
        <p class="mb-0">{{ description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardCount',
  props: ['label', 'total', 'description', 'icon', 'classes'],
}
</script>



// WEBPACK FOOTER //
// src/components/CardCount.vue